import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getLocalStorageItem } from "../Utils";
function PublicAuth(props) {
  const isAuthenticated = () => {
    const user = getLocalStorageItem("isLoggedIn");
    // const user = true;
    return user;
  };
  return isAuthenticated() ? (
    <>
      {" "}
      <Navigate to="/allGame" />
    </>
  ) : (
    <Outlet />
  );
}
export default PublicAuth;
